module.exports = __webpack_public_path__ + "static/img/CgoRDGRCU-OAU5PpAAtGQDbqFi0177.e188f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGRCU-OAU5PpAAtGQDbqFi0177.png
// module id = oqYA
// module chunks = 73